import { GetRulesetResponse } from "src/api/generated/frontend_internal_v1";
import React from "react";

/** Data provided by the {@link SINGLE_RULESET_CONTEXT} */
export type SingleRulesetContext = {
    /** The currently available ruleset */
    ruleset: GetRulesetResponse;

    /** Reload the ruleset's information */
    reset: () => Promise<void>;
};

/** {@link React.Context} to access the groups */
const SINGLE_RULESET_CONTEXT = React.createContext<SingleRulesetContext>({
    ruleset: {
        description: "",
        instances: [],
        name: "",
        rules: [],
        uuid: "",
    },

    /**
     * Reset the ruleset
     *
     * @returns a resolved promise
     */
    reset: () => Promise.resolve(),
});
SINGLE_RULESET_CONTEXT.displayName = "SingleRuleset";
export default SINGLE_RULESET_CONTEXT;
